import store from 'redux/config'
import {TransitionHookType} from 'commonTypes'
import {fetchHomeStats, fetchTotals, TotalsAC} from 'redux/totals/totals.duck'
import {fetchFilterOptions} from 'redux/totals/gridSession.duck'
import {
  AuthClientType,
  isAuthenticated,
  isTokenExpired,
  renewToken,
  handleAuth,
  login,
  loginCallback,
} from 'helpers/security'
import {handleError, hasRouteChanged} from 'helpers/common'
import {RouterStates} from 'router/states/routerStates.enum'
import {HookMatchCriteria} from '@uirouter/react'
import {select_gridSession} from '../../redux/totals/selectors'

const {dispatch} = store

export const handleAuthenticationCriteria: HookMatchCriteria = {
  to: state => state?.name !== RouterStates.loginCallback,
}

export const handleAuthenticationHook = (authClient: AuthClientType) => async () => {
  if (!isAuthenticated()) {
    await login(authClient)
    return false
  } else if (isTokenExpired()) {
    await renewToken(authClient, 'idToken')
  }

  await handleAuth(authClient, dispatch)
}

export const handleLoginCallbackCriteria: HookMatchCriteria = {
  to: state => state?.name === RouterStates.loginCallback,
}

export const handleLoginCallbackHook = (authClient: AuthClientType) => async (transition) => {
  try {
    await loginCallback(authClient)
    return transition.router.stateService.target(RouterStates.home)
  } catch (err) {
    handleError('OKTA / Login Callback', err)
  }
}

export const getTabTotalsHook: TransitionHookType = {
  criteria: {},
  callback: () => {
    dispatch(fetchTotals())
  },
}

export const getHomeStatsHook: TransitionHookType = {
  criteria: {
    to: state => state?.name === RouterStates.home,
  },
  callback: transition => {
    const {filters} = transition.params()

    const gridSession = select_gridSession(store.getState())

    const shouldUsePrevStateValue = (filters.jobStatus.length === 0 && filters.databaseId.length === 0) && (gridSession.filters.jobStatus.length > 0 || gridSession.filters.databaseId.length > 0)
    shouldUsePrevStateValue ? dispatch(TotalsAC.filtersApplied(gridSession.filters)) : dispatch(TotalsAC.filtersApplied(filters))

    dispatch(fetchFilterOptions())
    dispatch(fetchHomeStats())
  },
}

export const getHomeStatsExitHook: TransitionHookType = {
  criteria: {
    to: state => state?.name !== RouterStates.home,
    from: state => state?.name === RouterStates.home,
  },
  callback: transition => {
    if (hasRouteChanged(transition)) {
      dispatch(TotalsAC.hydrateApplied(false))
      dispatch(TotalsAC.homeStatsReset())
    }
  },
}
